import { useTranslation } from 'react-i18next'
import Header from '@/components/layout/header'
import Footer from '@/components/layout/footer'
import RoadmapHero from './hero'
import Phase from './phase'
import RoadmapCta from './cta'
import Seo from '@/components/seo/seo'
import { breadcrumbSchema, serviceSchema } from '@/components/seo/json-ld'
import { resolveLang } from '@/lib/site'

export default function Roadmap() {
  const { t, i18n } = useTranslation()
  const lang = resolveLang(i18n.resolvedLanguage)

  const services = ['Assessment', 'Build', 'Operate'].map((name, i) =>
    serviceSchema(lang, {
      name,
      description: t(`services.items.${i}.description`) as string,
      path: '/roadmap',
    }),
  )

  return (
    <>
      <Seo
        title={t('seo.roadmap.title') as string}
        description={t('seo.roadmap.description') as string}
        path="/roadmap"
        jsonLd={[
          breadcrumbSchema(lang, [
            { name: 'Bravic', path: '/' },
            { name: t('seo.roadmap.title') as string, path: '/roadmap' },
          ]),
          ...services,
        ]}
      />
      <Header />
      <main className="relative pt-20 md:pt-28 lg:pt-32 pb-12 md:pb-24 overflow-hidden bg-[radial-gradient(circle_at_20%_30%,rgba(0,166,147,0.05)_0%,transparent_50%),radial-gradient(circle_at_80%_70%,rgba(91,218,198,0.03)_0%,transparent_50%)]">
        <RoadmapHero />
        <Phase i18nKey="roadmap.phase01" layout="left" />
        <Phase i18nKey="roadmap.phase02" layout="right" />
        <Phase i18nKey="roadmap.phase03" layout="left" />
        <RoadmapCta />
      </main>
      <Footer />
    </>
  )
}
